export class CustomerIdentifiers {
  igsCustomerNumber: string;
  partnerCustomerNumber: string;
  leadNumber: string;
  abpAccountNumber: string;
  excelergyLdcAccountNumber: string;
  salesforceId: string;
  monitoringIdentificationCode: string;
  inverterTypeCode: string;
  productionPortalUrl: string;
  systemKey: string;
}
